import axios from 'axios'

var user_token_obj = document.querySelector('meta[name="user-token"]')
if(user_token_obj!=null){
  var user_token = user_token_obj.getAttribute('content')
} else {
  var user_token = null
}

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    'USER-TOKEN' : user_token,
}

export default axios;
